import 'react-hot-loader/patch';
import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Page, Button, Toolbar} from 'react-onsenui';
import './styles/index.scss';
import './styles/chat.scss';

import ChatHeader from "./components/chat-header";
import ChatBody from "./components/chat-body";
import ChatFooter from './components/chat-footer';

// Onsen UI Styling and Icons
class App extends React.Component {

  render() {
    const {title} = this.props;
    return (
      <Page renderToolbar={() => <ChatHeader title={title} mode={process.env.NODE_ENV} />}>
        <ChatBody></ChatBody>
        <ChatFooter></ChatFooter>
      </Page>
    );
  }
}

App.propTypes = {
  title: PropTypes.string
};

const mapStateToProps = (state, props) => ({
  protocol: state.chatRoot.protocol,
  title: state.chatRoot.title
});

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/app.jsx